import { ShiftModel } from "@/models/ShiftModel";
import { getMidnight } from "@/helpers/getMidnight";
import { HH, MM } from "@/helpers/date_time";

export default {
    methods: {
        sortedAndFilteredList(arr) {
            let byShifts = {};

            arr.forEach(v => {
                if (!byShifts[v.shift_id]) {
                    byShifts[v.shift_id] = [];
                }
                byShifts[v.shift_id].push(v);
            });

            Object.keys(byShifts).forEach(shift_id => {
                let arr = byShifts[shift_id];
                arr = this.filter(arr); // Если закончено в прошлом дне (т.е. закончили и прошли через полночь), то скрываем
                arr = this.sort(arr); // Вверх те, что в работе, а внизу уже законченные (чтобы сверху всегда были задачи которые в работе)
                byShifts[shift_id] = arr;
            });

            return byShifts;
        },
        getShiftName(shift_id) {
            const m = new ShiftModel(shift_id);
            return m.dir?.name ?? 'Без названия';
        },
        filter(arr) {
            const midnight = getMidnight();
            return arr.filter(v => {
                return !v.is_done
                    ||
                    (v.is_done && v.done_time >= midnight)
            });
        },
        sort(arr) {
            arr = arr.sort(
                (a, b) => {
                    if (a.is_done > b.is_done) return 1;
                    if (a.is_done < b.is_done) return -1;
                    return b.create_time - a.create_time;
                }
            );
            return arr;
        },
        HH(h) { return HH(h); },
        MM(m) { return MM(m); },
        getDeadlineColor(deadline) {
            const d = new Date();
            const time = 3600*d.getHours() + 60*d.getMinutes() + d.getSeconds();
            let color = '';
            if (deadline - time <= 3600) {
                color = 'text-bg-warning';
            }
            if (deadline - time <= 0) {
                color = 'text-bg-danger';
            }
            return color;
        },
    }
}